(() => {
  const normalize = value => value.normalize('NFKC').toLowerCase().replace(/[\s\-‐‑‒–—―−ー]/g, '');
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';
    const query = root.querySelector('[data-query]');
    const buttons = [...root.querySelectorAll('[data-maker]')].filter(el => el.tagName === 'BUTTON');
    const groups = [...root.querySelectorAll('[data-group]')];
    let maker = '';
    function update() {
      const terms = query.value.trim().split(/\s+/).map(normalize).filter(Boolean);
      let known = 0, unknown = 0;
      for (const group of groups) {
        let shown = 0;
        for (const item of group.querySelectorAll('[data-model]')) {
          const matches = (!maker || maker === group.dataset.maker) && terms.every(term => normalize(group.dataset.maker + item.dataset.model).includes(term));
          item.hidden = !matches;
          if (matches) { shown++; item.dataset.model.includes('不明') ? unknown++ : known++; }
        }
        group.hidden = shown === 0;
      }
      root.querySelector('[data-count]').textContent = `${known}件の型番・型番不明の報告${unknown}件`;
      root.querySelector('[data-empty]').hidden = known + unknown > 0;
      for (const button of buttons) button.setAttribute('aria-pressed', String(button.dataset.maker === maker));
    }
    query.addEventListener('input', update);
    for (const button of buttons) button.addEventListener('click', () => { maker = button.dataset.maker; update(); });
    root.querySelector('[data-reset]').addEventListener('click', () => { maker = ''; query.value = ''; update(); query.focus(); });
    root.querySelector('[data-controls]').hidden = false;
    update();
  }
  const boot = () => document.querySelectorAll('[data-ih-search]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
